import { useContext, useEffect, useState } from "react";
import {
  Animate,
  AuthContext,
  Card,
  Paginate,
  Search,
  Table,
  useAPI,
  ViewContext
} from "@/components/lib";

const Applications = () => {
  const viewContext = useContext(ViewContext);
  const authContext = useContext(AuthContext);

  // state
  const [search, setSearch] = useState<any>("");
  const [page, setPage] = useState<any>(1);
  const [applications, setApplications] = useState<any>([]);
  const [totalPages, setTotalPages] = useState<any>(1);

  // show 20 results at a time
  const limit = 20;

  const { data: applicationsData, loading: applicationsLoading } = useAPI(
    `${authContext.remote_server}/api/player/pending?firstName=${search}&lastName=${search}&page=${page}&limit=${limit}`
  );

  useEffect(() => {
    if (applicationsData?.data?.length > 0) {
      const playersList = applicationsData.data.map((player: any) => ({
        id: player.id,
        number: player.shirt || "0",
        name: player.first_name + " " + player.last_name,
        email: player.email || "No email",
        otp: player.otp
      }));

      setPage(applicationsData.currentPage);
      setApplications(playersList);
      setTotalPages(applicationsData.totalPages);
    }
  }, [applicationsData]);

  function reviewApplication(data, review) {
    if (!data.otp) return viewContext.notification.show("No validation found", "error");
    const url = `${authContext.remote_server}/api/player/${
      review ? "accept" : "deny"
    }/${data.otp}`;
    const text =
      "Are you sure you want to " +
      (review ? "accept" : "deny") +
      " " +
      data.name +
      "'s application?";
    const buttonText = review ? "Accept" : "Reject";

    viewContext.modal.show(
      {
        form: {},
        buttonText,
        text,
        textClassName: "font-bold text-center text-2xl text-black",
        url,
        method: "GET",
        destructive: true
      },
      () => {
        viewContext.notification.show(
          `Player ${review ? "accepted" : "rejected"}`,
          "success",
          true
        );
        setApplications((prev: any) =>
          prev.filter((player: any) => player.id !== data.id)
        );
      }
    );
  }

  return (
    <Animate>
      <Card>
        <div className="flex items-center justify-between gap-4 w-full">
          <Search
            throttle={1000}
            callback={(x) => setSearch(x)}
            className="w-full mb-4"
          />

          <Paginate
            page={page}
            limit={limit}
            total={totalPages || 1}
            onChange={(x) => setPage(x)}
            className="w-fit mb-4 gap-2 justify-end border-l-2 border-gray-400 pl-4"
          />
        </div>
        <Table
          data={applications}
          loading={applicationsLoading}
          show={["number", "name", "email"]}
          actions={{
            custom: [
              {
                action: (data: any) => reviewApplication(data, true),
                icon: "check-circle",
                className: "text-green-500"
              },
              {
                action: (data: any) => reviewApplication(data, false),
                icon: "x-circle",
                className: "text-red-500"
              }
            ]
          }}
        />
      </Card>
    </Animate>
  );
};

export default Applications;
